export default "__VITE_ASSET__Bqc$4nXx__"